import React from 'react';
import { Link } from 'react-router-dom';

export default function HomePage() {
  return (
    <div style={{ fontFamily: 'IBM Plex Sans, sans-serif', color: '#1a1a1a', minHeight: '100vh' }}>

      {/* Nav */}
      <nav style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '24px 60px', borderBottom: '1px solid #e0e0e0' }}>
        <span style={{ fontSize: 13, fontWeight: 700, letterSpacing: 3, textTransform: 'uppercase' }}>
          Clarity<span style={{ fontWeight: 300, opacity: 0.5 }}> Reporting</span>
        </span>
        <div style={{ display: 'flex', gap: 24, alignItems: 'center' }}>
          <Link to="/sample-report" style={{ fontSize: 13, color: '#888', textDecoration: 'none' }}>See a Sample Report</Link>
          <Link to="/login" style={{ fontSize: 13, color: '#888', textDecoration: 'none' }}>Sign In</Link>
          <Link to="/register" style={{ fontSize: 13, fontWeight: 700, letterSpacing: 1, textTransform: 'uppercase', textDecoration: 'none', color: '#fff', background: '#1a1a1a', padding: '10px 24px' }}>Start Free</Link>
        </div>
      </nav>

      {/* Hero */}
      <div style={{ maxWidth: 860, margin: '0 auto', padding: '100px 40px 80px', textAlign: 'center' }}>
        <div style={{ display: 'inline-block', background: '#FFE066', color: '#1a1a1a', fontSize: 11, fontWeight: 700, letterSpacing: 3, textTransform: 'uppercase', padding: '6px 16px', marginBottom: 32 }}>
          Independent SEO Data
        </div>
        <h1 style={{ fontSize: 56, fontWeight: 700, lineHeight: 1.1, letterSpacing: -1.5, margin: '0 0 24px' }}>
          Finally know if your<br />SEO is working.
        </h1>
        <p style={{ fontSize: 20, color: '#555', lineHeight: 1.6, maxWidth: 600, margin: '0 auto 48px' }}>
          Every week, we send you an independent report on your website rankings, your competitors, and the exact question to ask your SEO provider.
        </p>
        <div style={{ display: 'flex', gap: 16, justifyContent: 'center', alignItems: 'center', flexWrap: 'wrap' }}>
          <Link to="/register" style={{ display: 'inline-block', padding: '16px 48px', background: '#1a1a1a', color: '#fff', fontSize: 14, fontWeight: 700, letterSpacing: 1, textTransform: 'uppercase', textDecoration: 'none' }}>
            Get Started &mdash; $20/mo
          </Link>
          <Link to="/sample-report" style={{ display: 'inline-block', padding: '16px 32px', border: '1px solid #e0e0e0', color: '#1a1a1a', fontSize: 13, fontWeight: 700, letterSpacing: 1, textTransform: 'uppercase', textDecoration: 'none' }}>
            See a Sample Report
          </Link>
        </div>
        <p style={{ fontSize: 12, color: '#aaa', marginTop: 16 }}>No contracts. Cancel any time.</p>
      </div>

      {/* How it works */}
      <div style={{ borderTop: '1px solid #e0e0e0', borderBottom: '1px solid #e0e0e0', background: '#fafafa', padding: '80px 40px' }}>
        <div style={{ maxWidth: 860, margin: '0 auto' }}>
          <div style={{ fontSize: 11, fontWeight: 700, letterSpacing: 3, textTransform: 'uppercase', color: '#888', textAlign: 'center', marginBottom: 48 }}>How It Works</div>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 40 }}>
            {[
              { n: '01', title: 'Connect your site', body: 'Add your website and up to 3 competitor sites. Optionally connect Google Search Console for even more accurate data.' },
              { n: '02', title: 'We do the work', body: 'Every week we pull your keyword rankings, compare them against your competitors, and identify the keywords you are missing.' },
              { n: '03', title: 'Read your report', body: 'Get a plain-English summary in your inbox every week. See what improved, what dropped, and what question to ask your SEO provider.' },
            ].map(item => (
              <div key={item.n}>
                <div style={{ fontSize: 32, fontWeight: 700, fontFamily: 'monospace', color: '#e0e0e0', marginBottom: 12 }}>{item.n}</div>
                <div style={{ fontSize: 16, fontWeight: 700, marginBottom: 8 }}>{item.title}</div>
                <div style={{ fontSize: 14, color: '#666', lineHeight: 1.7 }}>{item.body}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* What you get */}
      <div style={{ maxWidth: 860, margin: '0 auto', padding: '80px 40px' }}>
        <div style={{ fontSize: 11, fontWeight: 700, letterSpacing: 3, textTransform: 'uppercase', color: '#888', textAlign: 'center', marginBottom: 48 }}>What You Get Every Month</div>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 2 }}>
          {[
            { icon: '\u2191', label: 'Weekly keyword rankings', desc: 'See exactly where you rank for your top 25 keywords, powered by Google Search Console.' },
            { icon: '\u25a0', label: 'Competitor gap analysis', desc: 'Discover the keywords your competitors rank for that you are completely missing.' },
            { icon: '\u25cb', label: 'SEO health score', desc: 'A monthly technical audit of your site. Know what is broken before Google penalizes you.' },
            { icon: '\u2665', label: 'Monthly executive summary', desc: 'Plain English. Biggest win, biggest concern, and the one question to ask your SEO provider.' },
          ].map(item => (
            <div key={item.label} style={{ padding: '28px 32px', border: '1px solid #e0e0e0' }}>
              <div style={{ fontSize: 24, marginBottom: 12 }}>{item.icon}</div>
              <div style={{ fontSize: 15, fontWeight: 700, marginBottom: 6 }}>{item.label}</div>
              <div style={{ fontSize: 13, color: '#666', lineHeight: 1.7 }}>{item.desc}</div>
            </div>
          ))}
        </div>
      </div>

      {/* The question */}
      <div style={{ background: '#1a1a1a', color: '#fff', padding: '80px 40px', textAlign: 'center' }}>
        <div style={{ maxWidth: 700, margin: '0 auto' }}>
          <div style={{ fontSize: 11, fontWeight: 700, letterSpacing: 3, textTransform: 'uppercase', color: 'rgba(255,255,255,0.4)', marginBottom: 24 }}>The Feature Everyone Loves</div>
          <div style={{ background: '#FFE066', color: '#1a1a1a', padding: '28px 36px', marginBottom: 32, textAlign: 'left' }}>
            <div style={{ fontSize: 11, fontWeight: 700, letterSpacing: 2, textTransform: 'uppercase', color: '#7a6a00', marginBottom: 8 }}>Ask Your SEO Provider This Month</div>
            <div style={{ fontSize: 17, fontStyle: 'italic', lineHeight: 1.6 }}>&ldquo;Our ranking for &lsquo;hardwood floor installation&rsquo; dropped 6 positions this month. What caused this and what is the plan to recover?&rdquo;</div>
          </div>
          <p style={{ fontSize: 15, color: 'rgba(255,255,255,0.6)', lineHeight: 1.7 }}>
            Every month, Clarity automatically generates a specific question based on your real data. Walk into your next agency meeting knowing exactly what to ask.
          </p>
        </div>
      </div>

      {/* Pricing */}
      <div style={{ maxWidth: 500, margin: '0 auto', padding: '80px 40px', textAlign: 'center' }}>
        <div style={{ fontSize: 11, fontWeight: 700, letterSpacing: 3, textTransform: 'uppercase', color: '#888', marginBottom: 48 }}>Simple Pricing</div>
        <div style={{ border: '2px solid #1a1a1a', padding: '48px 40px' }}>
          <div style={{ fontSize: 48, fontWeight: 700, fontFamily: 'monospace', marginBottom: 4 }}>$20</div>
          <div style={{ fontSize: 14, color: '#888', marginBottom: 32 }}>per month, one website</div>
          <div style={{ textAlign: 'left', marginBottom: 32 }}>
            {[
              '1 website tracked',
              'Up to 3 competitor sites',
              '25 keywords monitored weekly',
              'Google Search Console integration',
              'Monthly SEO health audit',
              'Monthly executive summary email',
              'Ask Your SEO Provider question',
            ].map(f => (
              <div key={f} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '8px 0', borderBottom: '1px solid #f0f0f0', fontSize: 14 }}>
                <span style={{ color: '#1a7a1a', fontWeight: 700 }}>✓</span> {f}
              </div>
            ))}
          </div>
          <Link to="/register" style={{ display: 'block', padding: '16px', background: '#1a1a1a', color: '#fff', fontSize: 13, fontWeight: 700, letterSpacing: 1, textTransform: 'uppercase', textDecoration: 'none' }}>
            Start Free Trial
          </Link>
        </div>
      </div>

      {/* Footer */}
      <footer style={{ borderTop: '1px solid #e0e0e0', padding: '32px 60px', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 16 }}>
        <span style={{ fontSize: 11, fontWeight: 700, letterSpacing: 3, textTransform: 'uppercase', opacity: 0.4 }}>Clarity Reporting</span>
        <div style={{ display: 'flex', gap: 24, flexWrap: 'wrap' }}>
          <Link to="/sample-report" style={{ fontSize: 12, color: '#888', textDecoration: 'none' }}>Sample Report</Link>
          <Link to="/privacy" style={{ fontSize: 12, color: '#888', textDecoration: 'none' }}>Privacy Policy</Link>
          <Link to="/terms" style={{ fontSize: 12, color: '#888', textDecoration: 'none' }}>Terms of Service</Link>
          <Link to="/agencies" style={{ fontSize: 12, color: '#888', textDecoration: 'none' }}>For Agencies</Link>
        </div>
      </footer>

    </div>
  );
}
